module.exports = __webpack_public_path__ + "images/home-dingtalk-work/dingtalk_qrcode-c94c79f85501dd846c8b8db07d7a3cec.png";